<!-- 用户管理 -->
<template>
  <el-main>
    <div class="tableList">
      <div class="search">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item><el-input v-model="formInline.keyWord" clearable placeholder="请输入关键字"></el-input></el-form-item>
          <el-form-item><el-button type="primary" @click="()=>{ paging.page = 1;this.getList() }" icon="el-icon-search" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}">检索</el-button></el-form-item>
          <div :style="{float:'right'}">
            <el-form-item><el-button size="small" type="primary" icon="el-icon-download" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}" @click="downLoad">导出</el-button></el-form-item>
          </div>
        </el-form>
      </div>
      <div class="tableContent">
        <el-table
          class="table"
          ref="tableData"
          :data="table.tableData"
          border
          :height="table.tableHeight"
          element-loading-text="拼命加载中,请等待"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.1)"
        >
          <el-table-column prop="name" label="微信昵称" align="center"></el-table-column>
          <el-table-column prop="portrait" label="头像" align="center">
            <template slot-scope="scope">
              <el-image style="width: 50px; height: 50px;display: block;margin: 0 auto" :src="scope.row.portrait" fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
          <el-table-column prop="gender" label="性别" align="center"></el-table-column>
          <el-table-column prop="wechat" label="微信号" align="center"></el-table-column>
          <el-table-column prop="city" label="留学城市" align="center"></el-table-column>
          <el-table-column prop="school" label="留学学校" align="center"></el-table-column>
        </el-table>
      </div>
      <div class="tablePagination">
        <el-pagination
          class="customPagination"
          @size-change="handlePaginationChange"
          @current-change="handlePaginationCurrentChange"
          :current-page="paging.page"
          :page-sizes="[15, 25, 50]"
          :page-size="paging.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="paging.total"
        >
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
  import ExportJsonExcel from "js-export-excel";
  export default {
    name: 'UserManagement',
    data () {
      return {
        formInline: { // 查询参数
          keyWord: '' // 关键字
        },
        table: { // 表格参数
          tableData:[], // 表格数据
          tableHeight: null, // 表格高度
        },
        paging: { // 分页参数
          page: 1,// 页码
          size: 15, // 条数
          total: 0, // 总数
        },
      }
    },
    methods: {
      // 获取表格数据
      getList(){
        let parameter = [{
          "field":"status",
          "fun":"ne",
          "value": "0"
        },{
          "field":"name",
          "fun":"like",
          "value": this.formInline.keyWord
        }];
        this.$api.findMember({
          page:this.paging.page,
          size:this.paging.size,
          parameter: JSON.stringify(parameter)
        }).then(res => {
          if (res.data.status == 200) {
            this.table.tableData = res.data.data.records;
            this.paging.total = Number(res.data.data.total);
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 分页部分改变条数
      handlePaginationChange(val) {
        this.paging.size = val;
        this.paging.page = 1;
        this.getList();
      },
      // 分页部分改变页码
      handlePaginationCurrentChange(val) {
        this.paging.page = val;
        this.getList();
      },
      // 导出User
      downLoad(){
        let data = this.table.tableData;//选中的数据
        let dataTable = [];
        if (data && data.length > 0) {
          for (let i in data) {
            if (data[i]) {
              let obj = {
                微信昵称: data[i].name,
                手机号: data[i].phone,
                性别: data[i].gender,
                微信号: data[i].wechat,
                留学城市: data[i].city,
                留学学校: data[i].school
              };
              dataTable.push(obj);
            }
          }
          this.exportToExcel(dataTable);
        }
      },
      //定义导出Excel表格事件
      exportToExcel (dataTable) {
        let option = {};
        option.fileName = "用户信息";
        option.datas = [
          {
            sheetData: dataTable,
            sheetName: "sheet",
            sheetFilter: [
              "微信昵称",
              "手机号",
              "性别",
              "微信号",
              "留学城市",
              "留学学校"
            ],
            sheetHeader: [
              "微信昵称",
              "手机号",
              "性别",
              "微信号",
              "留学城市",
              "留学学校"
            ]
          }
        ];
        let toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
      },
      // table的高度
      getTableHeight(){
        let that = this;
        if($(".table").length > 0) {
          // 表格高度初始化事件
          $(".table").height(window.innerHeight - $(".table").offset().top - 70);
          $(".table .el-table__empty-block").height(window.innerHeight - $(".table").offset().top - 132);
          that.table.tableHeight = window.innerHeight - $(".table").offset().top - 70;
          // 窗口改变事件
          window.onresize = function () { // 定义窗口大小变更通知事件
            if($(".table").length > 0) {
              $(".table").height(window.innerHeight - $(".table").offset().top - 70);
              $(".table .el-table__empty-block").height(window.innerHeight - $(".table").offset().top - 132);
              that.table.tableHeight = window.innerHeight - $(".table").offset().top - 70;
            }
          };
        }
      },
    },
    mounted() {
      // 获取页面表格高度
      this.getTableHeight();
      // 获取列表
      this.getList();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/UserManagement.vue